import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4617edde"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "message-box"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "title"
}, "图文详情", -1));
const _hoisted_3 = {
  style: {
    "max-width": "800px",
    "text-overflow": "ellipsis",
    "white-space": "nowrap",
    "overflow": "hidden"
  }
};
import { ref, watch } from 'vue';
import { getNewsReplyById } from '@/api/greeting';
import { useVModel } from '@vueuse/core';
// import { useRoute } from 'vue-router'

export default {
  __name: 'index',
  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    newsId: {
      type: Number,
      required: true
    }
  },
  emits: ['update:modelValue'],
  setup(__props) {
    const props = __props;
    const isVisible = useVModel(props);

    // const route = useRoute()
    // const { newsId } = route.params

    const newGreetingData = ref({});
    const notes = ref([]);
    const getNewsGreetingData = async () => {
      const res = await getNewsReplyById(props.newsId);
      newGreetingData.value = res;
      notes.value = JSON.parse(res.note);
    };
    watch(isVisible, async value => {
      if (!value) return;
      await getNewsGreetingData();
    });
    return (_ctx, _cache) => {
      const _component_el_descriptions_item = _resolveComponent("el-descriptions-item");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_descriptions = _resolveComponent("el-descriptions");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_dialog, {
        modelValue: _unref(isVisible),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(isVisible) ? isVisible.value = $event : null),
        width: "60%",
        "close-on-click-modal": false
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("h3", null, "关键字：" + _toDisplayString(newGreetingData.value.keyword), 1), notes.value.length ? (_openBlock(true), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(notes.value, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: "header",
            key: index
          }, [_createVNode(_component_el_descriptions, {
            title: `第${index + 1}组`,
            border: "",
            column: 2,
            style: {
              "width": "100%"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
              width: "25%",
              label: "标题",
              span: 1
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(item.title), 1)]),
              _: 2
            }, 1024), _createVNode(_component_el_descriptions_item, {
              width: "25%",
              label: "描述",
              span: 1
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(item.description), 1)]),
              _: 2
            }, 1024), _createVNode(_component_el_descriptions_item, {
              width: "25%",
              label: "图片url",
              span: 2,
              "class-name": "description-column"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_image, {
                src: item.picUrl,
                class: "pic-class",
                "preview-src-list": [item.picUrl]
              }, null, 8, ["src", "preview-src-list"])]),
              _: 2
            }, 1024), _createVNode(_component_el_descriptions_item, {
              width: "25%",
              label: "点击跳转路径",
              span: 2
            }, {
              default: _withCtx(() => [_createVNode(_component_el_tooltip, {
                class: "box-item",
                effect: "dark",
                content: item.url,
                placement: "bottom-end"
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_3, _toDisplayString(item.url), 1)]),
                _: 2
              }, 1032, ["content"])]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1032, ["title"])]);
        }), 128)) : _createCommentVNode("", true)])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
};